/**
 * Đăng nhập xong thì quay về đâu.
 *
 * ── Vì sao không phải lúc nào cũng "về đúng chỗ đang đứng" ──────────────────
 *
 * Luật cũ là một dòng: `login-to?to=<đường dẫn hiện tại>`. Nó đúng cho địa chỉ
 * PANEL — người được gửi thẳng link `/rewards/grant` mà bị ném về trang chủ sau
 * khi đăng nhập sẽ phải tự đi tìm lại trang đó.
 *
 * Nhưng nó sai cho các trang TÀI LIỆU CÔNG KHAI, và sai theo kiểu trông như
 * chẳng có gì xảy ra: đứng ở `/commands` bấm Đăng nhập, đi qua Discord, rồi
 * quay lại đúng `/commands` — một trang không đòi phiên đăng nhập, nên nó vẽ y
 * hệt lúc trước, kèm nguyên cái nút "Đăng nhập" ở góc. Phiên ĐÃ được tạo, nhưng
 * màn hình không có một dấu hiệu nào nói ra điều đó, nên người dùng kết luận
 * hợp lý nhất có thể: đăng nhập hỏng. Rồi bấm lại.
 *
 * Nên luật là: về đúng chỗ đang đứng NẾU chỗ đó là địa chỉ panel; còn đứng ở
 * trang công khai thì về gốc panel — từ 13/08/2026 gốc panel CHÍNH LÀ trang chủ
 * với lưới server, nên đích đó giờ đúng theo cả nghĩa đen (xem `pages/Home.tsx`).
 *
 * Khai ở một chỗ vì bốn nơi cùng hỏi câu này — đầu trang công khai, trang giới
 * thiệu, màn hình đăng nhập của panel, và lớp xử lý 401 trong `api.ts`. Bốn bản
 * viết tay là bốn cơ hội để một cái được sửa còn ba cái kia thì không.
 */

/**
 * Địa chỉ mở được khi CHƯA đăng nhập.
 *
 * Phải khớp với các `<Route>` nằm ngoài `<Layout />` trong `main.tsx`. Thêm một
 * trang công khai mà quên thêm vào đây thì hậu quả chỉ là đăng nhập từ trang đó
 * quay lại chính nó — đúng lỗi mô tả ở trên, và cũng im lặng y như vậy.
 */
const PUBLIC_PATHS: ReadonlySet<string> = new Set([
  '/features',
  '/commands',
  '/setup',
  '/terms',
  '/privacy',
  '/denied',
]);

/** true = trang này đọc được mà không cần phiên đăng nhập. */
export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATHS.has(pathname);
}

/**
 * Link "Đăng nhập bằng Discord" cho trang đang mở.
 *
 * Gốc panel (`/`) không nằm trong `PUBLIC_PATHS` dù người chưa đăng nhập vẫn
 * thấy trang giới thiệu ở đó — vì đó CHÍNH là chỗ ta muốn đưa họ tới, nên hai
 * nhánh cho ra cùng một kết quả.
 */
export function loginHref(pathname: string): string {
  const to = isPublicPath(pathname) ? '/' : pathname;
  return `/api/auth/login-to?to=${encodeURIComponent(to)}`;
}
